function multiLevelFilter(array:any, value:any) {
    function find(object:any):any {
        return Object
            .values(object)
            .some(v => v === value || v && typeof v === 'object' && find(v));
    }

    return array.filter(find);
}

export {multiLevelFilter}